import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { valueOrDefaultValue } from '../../../../../../../../../../utils/globals/valueOrDefaultValue'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useParams } from 'react-router'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { WorkingCenterStationModelType } from '@teinor/erp/types/company/workingCenter/workingCenterStation'


interface ModalCEWorkingCenterStationProps extends ModalEditComponentProps { }

const ModalCEWorkingCenterStation: React.FC<ModalCEWorkingCenterStationProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { id } = useParams()

    const fields: FormRender<WorkingCenterStationModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: id
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                },
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/workingCenter/workingCenterStation/updateWorkingCenterStation'} translations={{ title: t('editWorkingCenterStation', 'Editar puesto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/workingCenter/workingCenterStation/createWorkingCenterStation'} translations={{
        title: t('createWorkingCenterStation', 'Crear puesto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEWorkingCenterStation